import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPlus = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 9,
	height: 10,
	viewBox: "0 0 9 10",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M0.340156 6.12V4.5H8.82016V6.12H0.340156ZM3.76016 0.859999H5.42016V9.76H3.76016V0.859999Z",
		fill: "white"
	})
});
export { SvgPlus as ReactComponent };
